import { Avatar, Box, Typography, styled } from '@mui/material';

const HeaderBox = styled(Box)(
  ({ theme }) => `
    padding: ${theme.spacing(2)};
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};
  `
);

interface Props {
  displayName?: string | null;
  email?: string | null;
  photoURL?: string | null;
}

export default function AccountMenuHeader({
  displayName,
  email,
  photoURL,
}: Props) {
  return (
    <HeaderBox>
      <Avatar alt={displayName ?? ''} src={photoURL ?? undefined} />
      <Typography variant='body1'>{email ?? ''}</Typography>
    </HeaderBox>
  );
}
